import React from 'react';
import ChoroplethSvg from '@splunk/dashboard-visualizations/ChoroplethSvg';
import { campusSvg } from '../../mockdata/campusSvg.js';

const CampusData = {
    fields: [
        {
            name: 'buildings',
        },
        {
            name: 'values',
        },
    ],
    columns: [
        ['ATX-270-B', 'N-224', 'VM-203', 'RF-380'],
        [10000, 55000, 90000, 75000],
    ],
};

const gradientEncoding = {
    featureId: 'primary[0]',
    value: 'primary[1]',
    fill: {
        field: 'primary[1]',
        format: {
            type: 'gradient',
            values: ['#FF7152', '#4BEBA8'],
        },
    },
};

const baseProps = {
    loading: false,
    width: 700,
    height: 500,
    options: {
        svg: campusSvg,
    },
    dataSources: {
        primary: { data: CampusData },
    },
};

export default () => <ChoroplethSvg {...baseProps} encoding={gradientEncoding} />;
